import React from 'react';
import TextFieldGroup from '../common/textFieldGroup';
import { PropTypes } from 'prop-types';

const ChangePasswordForm = ({errors, oldPassword, newPassword, confirmPassword, isLoading, onChange, onSubmit}) => {
    return (
      <form onSubmit={onSubmit} autoComplete="on" className="change-password-form">
        { errors.form && <div className="alert alert-danger">{errors.form}</div> }

        <TextFieldGroup
          field="oldPassword"
          label="Current password"
          value={oldPassword}
          error={errors.oldPassword}
          onChange={onChange}
          type="password"
        />

        <TextFieldGroup
          field="newPassword"
          label="New password"
          value={newPassword}
          error={errors.newPassword}
          onChange={onChange}
          type="password"
        />

        <TextFieldGroup
          field="confirmPassword"
          label="Confirm password"
          value={confirmPassword}
          error={errors.confirmPassword}
          onChange={onChange}
          type="password"
        />

        <div className="form-group"><button type="submit" className="btn btn-primary btn-lg" disabled={isLoading}>Confirm</button></div>
      </form>
    );
};

ChangePasswordForm.propTypes = {
	className: PropTypes.string, 
	errors: PropTypes.object, 
	oldPassword: PropTypes.string, 
	newPassword: PropTypes.string, 
	confirmPassword: PropTypes.string, 
	onChange: PropTypes.func, 
	onSubmit: PropTypes.func.isRequired, 
	isLoading: PropTypes.bool
};

export default ChangePasswordForm;